<p class="ui-heading-2-bold--s">Calendar View</p>

<bad-calendar-filters
  [initialFilters]="initialFilters"
  (filtersChange)="onFiltersChange($event)"
  (filtersCleared)="onFiltersCleared()">
</bad-calendar-filters>

<bsh-week-calendar
  [rooms]="roomsCalendarEvents()"
  [isLoading]="isLoading()"
  [sortDirection]="sortDirection()"
  [initialDate]="initialDate"
  (eventClick)="onEventClick($event)"
  (weekChange)="onWeekChange($event)"
  (sortChange)="onSortChange($event)">
</bsh-week-calendar>
